module.exports = __webpack_public_path__ + "img/CommentIconFilled.57c52991.svg";